const middleware = {}

middleware['load-cart-and-check-if-empty'] = require('../middleware/load-cart-and-check-if-empty.ts')
middleware['load-cart-and-check-if-empty'] = middleware['load-cart-and-check-if-empty'].default || middleware['load-cart-and-check-if-empty']

middleware['pagination'] = require('../middleware/pagination.ts')
middleware['pagination'] = middleware['pagination'].default || middleware['pagination']

export default middleware
